module.exports = __webpack_public_path__ + "img/session-organic-form-cinza-bottom.9db24c70.png";